// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    ADD_CLAIM_MASS_CHANNEL_PDI_FILE: 'ADD_CLAIM_MASS_CHANNEL_PDI_FILE',
    ADD_CLAIM_MASS_CHANNEL_PDI_PINS: 'ADD_CLAIM_MASS_CHANNEL_PDI_PINS',
    COPY_CLAIM_MASS_CHANNEL_PDI: 'COPY_CLAIM_MASS_CHANNEL_PDI',
    DELETE_CLAIM_MASS_CHANNEL_PDI_FILE: 'DELETE_CLAIM_MASS_CHANNEL_PDI_FILE',
    RESET_CLAIM_MASS_CHANNEL_PDI: 'RESET_CLAIM_MASS_CHANNEL_PDI',
    RESET_CLAIM_MASS_CHANNEL_PDI_CONFIRMATION_MODAL: 'RESET_CLAIM_MASS_CHANNEL_PDI_CONFIRMATION_MODAL',
    RESET_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION: 'RESET_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION',
    REVISE_CLAIM_MASS_CHANNEL_PDI: 'REVISE_CLAIM_MASS_CHANNEL_PDI',
    SET_CLAIM_MASS_CHANNEL_PDI: 'SET_CLAIM_MASS_CHANNEL_PDI',
    SET_CLAIM_MASS_CHANNEL_PDI_CONFIRMATION_MODAL: 'SET_CLAIM_MASS_CHANNEL_PDI_CONFIRMATION_MODAL',
    SET_CLAIM_MASS_CHANNEL_PDI_PRODUCT_DETAILS: 'SET_CLAIM_MASS_CHANNEL_PDI_PRODUCT_DETAILS',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_CLAIM_TYPES: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_CLAIM_TYPES',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_FILE: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_FILE',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_COPIED: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_COPIED',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_EDITABLE: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_EDITABLE',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_VALID_CLAIM: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_VALID_CLAIM',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_MODAL_MODE: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_MODAL_MODE',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_PIN: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_PIN',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_PROPERTY: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_PROPERTY',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_REFERENCE_INFO_PROPERTY: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_REFERENCE_INFO_PROPERTY',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME_COLLECTION: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME_COLLECTION',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_MASS_CHANNEL_PDI_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_MASS_CHANNEL_PDI_TEMPORARY_OBJECT_KEY'
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-list.js